// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RsC9j","newExpiryDate":"styles_newExpiryDate__32Sve","footer":"styles_footer__2qDsq"};